export const UPDATE_FORM = "documents/UPDATE_FORM";
export const START_DOCUMENT_EDITION = "documents/START_DOCUMENT_EDITION";
export const STOP_DOCUMENT_EDITION = "documents/STOP_DOCUMENT_EDITION";
export const UPDATE_DOCUMENT_FAILED = "documents/UPDATE_DOCUMENT_FAILED";
export const HYDRATE_FORM_DATA = "documents/HYDRATE_FORM_DATA";
export const RESET_FORM = "documents/RESET_FORM";
export const RESET_DOCUMENT_FORM_DATA = "documents/RESET_DOCUMENT_FORM_DATA";
